export default "__VITE_ASSET__5256fdf8__"